export const iconFontAwesomeMedicalHealthBookMedical = (
	<i className="fa-solid fa-book-medical"></i>
);
